import { defineAsyncComponent } from 'vue'
export default {
  advisor: defineAsyncComponent(() => import("/app/app/layouts/advisor.vue").then(m => m.default || m)),
  app: defineAsyncComponent(() => import("/app/app/layouts/app.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/app/layouts/default.vue").then(m => m.default || m)),
  onboarding: defineAsyncComponent(() => import("/app/app/layouts/onboarding.vue").then(m => m.default || m)),
  "portfolio-fetcher-v2": defineAsyncComponent(() => import("/app/app/layouts/portfolio-fetcher-v2.vue").then(m => m.default || m))
}